module.exports = __webpack_public_path__ + "img/store_stationery.488ba64d.png";